import type { InsightsProps } from 'instantsearch.js/es/middlewares';

/**
 * InstantSearch `insights` options that send each list of viewed hits once.
 * Every hits widget sends its hits as a view on each render, so without this
 * the same list reaches Algolia several times for one search.
 */
export const createInsightsOptions = (userToken?: string): InsightsProps => {
  const sentViews = new Set<string>();

  return {
    // instantsearch.js types these init params as a tuple, not as the options object it reads.
    insightsInitParams: {
      userToken,
    } as unknown as InsightsProps['insightsInitParams'],
    onEvent: (event, insightsClient) => {
      if (!event.insightsMethod || !insightsClient) return;

      if (event.eventType === 'view') {
        const { index, objectIDs } = event.payload as unknown as {
          index: string;
          objectIDs: string[];
        };
        const viewKey = `${index}:${objectIDs.join(',')}`;
        if (sentViews.has(viewKey)) return;
        sentViews.add(viewKey);
      }

      const algoliaSource = ['instantsearch'];
      if (event.eventModifier === 'internal') {
        algoliaSource.push('instantsearch-internal');
      }

      insightsClient(event.insightsMethod, {
        ...event.payload,
        algoliaSource,
      } as never);
    },
  };
};
